export class DepositoPix {

  id: string;
  dtHr: string;
  dtHrPg: string;
  empresaId: string;
  licencaId: string;
  instituicao: string;
  valor: number;
  historico: string;
  response: string;
	qrCode: string;
	copyPaste: string;
	endToEndId: string;
	contaOrigem: string;
	status: string;
  user: string;

  constructor(empresaId: string) {
    this.empresaId = empresaId;
    this.valor = 0.00;
  }

}
